// Code to manage the authentication of the user
let memoryToken = null;

export const AuthService = {
    setTokens({ accessToken, refreshToken }) {
        memoryToken = accessToken;
        sessionStorage.setItem('accessToken', accessToken);
        sessionStorage.setItem('refreshToken', refreshToken);
    },

    getAccessToken() {
        if (!memoryToken) {
            memoryToken = sessionStorage.getItem('accessToken');
        }
        return memoryToken;
    },

    getRefreshToken() {
        const refreshToken = sessionStorage.getItem('refreshToken');
        return refreshToken;
    },

    setUserData(user) {
        if (user) {
            sessionStorage.setItem('userData', JSON.stringify(user));
        }
    },

    getUserData() {
        const userData = sessionStorage.getItem('userData');
        return userData ? JSON.parse(userData) : null;
    },

    handleLoginSuccess(response) {

        if (!response) {
            console.error('No response data provided to handleLoginSuccess');
            return;
        }

        const { accessToken, refreshToken, user } = response;

        if (!accessToken || !refreshToken) {
            // console.error('Missing tokens in response:', { accessToken, refreshToken });
            return;
        }

        // Set tokens
        this.setTokens({ accessToken, refreshToken });

        // Set user data
        if (user) {
            this.setUserData(user);
        }

        // Verify storage
        // console.log('Storage after login:', {
        //     memoryToken: this.getAccessToken(),
        //     sessionToken: sessionStorage.getItem('accessToken'),
        //     userData: this.getUserData()
        // });
    },

    clearAuth() {
        memoryToken = null;
        sessionStorage.clear();
    },

    isAuthenticated() {
        try {
            const token = this.getAccessToken();
            const isAuth = !!token;
            // console.log('Checking authentication:', {
            //     hasToken: isAuth,
            //     memoryToken: memoryToken,
            //     sessionToken: sessionStorage.getItem('accessToken')
            // });

            if (!isAuth) {
                this.clearAuth();
            }

            return isAuth;
        } catch (error) {
            console.error('Error checking authentication:', error);
            return false;
        };
    },

    getUserRole() {
        try {
            const userData = this.getUserData();
            return userData?.role || 'guest';
        } catch (error) {
            console.error('Error getting user role:', error);
            return null;
        }
    },

    hasRequireRole(allowedRoles) {
        const userRole = this.getUserRole();
        return userRole && allowedRoles.includes(userRole);
    },

    getUserPermission() {
        const role = this.getUserRole();

        const permission = {
            'systemAdmin': ['home', 'files', 'hospitals', 'users'],
            'admin': ['home', 'files', 'hospitals', 'users'],
            'user': ['home', 'files'],
            'guest': ['home'],
        };

        return permission[role] || [];
    },

    hasPermission(permission) {
        const userPermission = this.getUserPermission();
        return userPermission.includes(permission);
    }
};
// เพิ่มเมธอดสำหรับเช็คสถานะปัจจุบัน
// checkAuthStatus() {
//     console.log('Current auth status:', {
//         memoryToken: memoryToken,
//         sessionToken: sessionStorage.getItem('accessToken'),
//         refreshToken: sessionStorage.getItem('refreshToken'),
//         userData: this.getUserData(),
//         isAuthenticated: this.isAuthenticated()
//     });
// }